import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ReactSVG from "react-svg";
import Media from "react-responsive";
import { xMediumScreen } from "@styles/constants";
import { Loader } from "@components/atoms";
import { CachedImage, StatusData, StatusDataFooter } from "@components/molecules";
import { getErrorMessage, statusMessages } from "@temp/intl";
import { Timer } from "@components/atoms/Timer";
import { useOrder } from "@saleor/sdk";
import { AlertChangePaymentMethod } from "@temp/components";
import { GatewayTypesEnum, OrderStatus, PaymentChargeStatusEnum } from "@globalTypes/globalTypes";
import { maybe } from "../../../../core/utils";
import * as S from "./styles";

var logoImg = require("../../../../images/logo-ep-ai-red.svg");

var equisImg = require("../../../../images/close.svg");

var loadingImg = require("../../../../images/EPtoSHOP.gif");

var logoShopImg = require("../../../../images/shopWithOutLogo.svg");

var goBackImg = require("../../../../images/arrowBack.svg");
/**
 * Pending status structure.
 */


var StatusPending = function StatusPending(_ref) {
  var _data$paymentStatus, _PaymentChargeStatusE, _data$paymentStatus2, _PaymentChargeStatusE2, _data$paymentStatus3, _PaymentChargeStatusE3, _data$paymentStatus4, _PaymentChargeStatusE4, _data$status, _data$trade, _data$paymentStatus5, _PaymentChargeStatusE5, _data$paymentStatus6, _PaymentChargeStatusE6;

  var data = _ref.data,
      goBack = _ref.goBack;
  var intl = useIntl();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      errors = _React$useState4[0],
      setErrors = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showChangePaymentMethod = _React$useState6[0],
      setShowChangePaymentMethod = _React$useState6[1];

  var _useOrder = useOrder(),
      paymentCreateAndOrderUpdate = _useOrder.paymentCreateAndOrderUpdate;

  var handlePayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderId, gateway, token) {
      var _dataError$error;

      var _yield$paymentCreateA, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return paymentCreateAndOrderUpdate(orderId, gateway, token);

            case 3:
              _yield$paymentCreateA = _context.sent;
              dataError = _yield$paymentCreateA.dataError;

              if (dataError && (dataError === null || dataError === void 0 ? void 0 : dataError.error) && (dataError === null || dataError === void 0 ? void 0 : (_dataError$error = dataError.error) === null || _dataError$error === void 0 ? void 0 : _dataError$error.length) > 0) {
                setErrors(dataError === null || dataError === void 0 ? void 0 : dataError.error);
              }

              setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePayment(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(S.Wrapper, null, React.createElement(S.Tile, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.Title, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.BackTitle, {
    onClick: goBack
  }, React.createElement(ReactSVG, {
    path: goBackImg
  }), React.createElement(S.BackTitleParragraph, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusPending.StatusPending.3471378517",
    defaultMessage: "back"
  })))), (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.REFUSED_PAYMENT ? React.createElement(FormattedMessage, statusMessages.stepNameRefusedPayment) : (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.PENDING && ((data === null || data === void 0 ? void 0 : (_data$paymentStatus = data.paymentStatus) === null || _data$paymentStatus === void 0 ? void 0 : _data$paymentStatus.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE = PaymentChargeStatusEnum.PENDING) === null || _PaymentChargeStatusE === void 0 ? void 0 : _PaymentChargeStatusE.toLowerCase()) || (data === null || data === void 0 ? void 0 : (_data$paymentStatus2 = data.paymentStatus) === null || _data$paymentStatus2 === void 0 ? void 0 : _data$paymentStatus2.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE2 = PaymentChargeStatusEnum.NOT_CHARGED) === null || _PaymentChargeStatusE2 === void 0 ? void 0 : _PaymentChargeStatusE2.toLowerCase())) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) ? React.createElement(FormattedMessage, statusMessages.stepNameWaitingPayment) : React.createElement(FormattedMessage, statusMessages.stepNamePending)))), React.createElement(S.Content, null, React.createElement(Media, {
    maxWidth: xMediumScreen
  }, React.createElement(S.Title, null, (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.REFUSED_PAYMENT ? React.createElement(FormattedMessage, statusMessages.stepNameRefusedPayment) : (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.PENDING && ((data === null || data === void 0 ? void 0 : (_data$paymentStatus3 = data.paymentStatus) === null || _data$paymentStatus3 === void 0 ? void 0 : _data$paymentStatus3.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE3 = PaymentChargeStatusEnum.PENDING) === null || _PaymentChargeStatusE3 === void 0 ? void 0 : _PaymentChargeStatusE3.toLowerCase()) || (data === null || data === void 0 ? void 0 : (_data$paymentStatus4 = data.paymentStatus) === null || _data$paymentStatus4 === void 0 ? void 0 : _data$paymentStatus4.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE4 = PaymentChargeStatusEnum.NOT_CHARGED) === null || _PaymentChargeStatusE4 === void 0 ? void 0 : _PaymentChargeStatusE4.toLowerCase())) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) ? React.createElement(FormattedMessage, statusMessages.stepNameWaitingPayment) : React.createElement(FormattedMessage, statusMessages.stepNamePending))), React.createElement(S.ContentContainer, null, React.createElement(S.Images, null, React.createElement(S.Image, null, React.createElement(ReactSVG, {
    path: logoImg
  })), React.createElement(S.Image, null, React.createElement(S.Gif, null, (data === null || data === void 0 ? void 0 : (_data$status = data.status) === null || _data$status === void 0 ? void 0 : _data$status.toUpperCase()) === OrderStatus.REFUSED_PAYMENT ? React.createElement("img", {
    alt: "cargando",
    src: equisImg
  }) : React.createElement("img", {
    alt: "cargando",
    src: loadingImg
  }))), React.createElement(S.Image, null, (data === null || data === void 0 ? void 0 : (_data$trade = data.trade) === null || _data$trade === void 0 ? void 0 : _data$trade.logoImage) ? React.createElement(S.ImageShop, null, React.createElement(CachedImage, {
    url: maybe(function () {
      var _data$trade2, _data$trade2$logoImag;

      return data === null || data === void 0 ? void 0 : (_data$trade2 = data.trade) === null || _data$trade2 === void 0 ? void 0 : (_data$trade2$logoImag = _data$trade2.logoImage) === null || _data$trade2$logoImag === void 0 ? void 0 : _data$trade2$logoImag.url;
    }),
    alt: maybe(function () {
      var _data$trade3, _data$trade3$logoImag, _data$trade4, _data$trade4$logoImag;

      return (data === null || data === void 0 ? void 0 : (_data$trade3 = data.trade) === null || _data$trade3 === void 0 ? void 0 : (_data$trade3$logoImag = _data$trade3.logoImage) === null || _data$trade3$logoImag === void 0 ? void 0 : _data$trade3$logoImag.alt) ? data === null || data === void 0 ? void 0 : (_data$trade4 = data.trade) === null || _data$trade4 === void 0 ? void 0 : (_data$trade4$logoImag = _data$trade4.logoImage) === null || _data$trade4$logoImag === void 0 ? void 0 : _data$trade4$logoImag.alt : "";
    }, "")
  }, React.createElement(React.Fragment, null))) : React.createElement(ReactSVG, {
    path: logoShopImg
  }))), (data === null || data === void 0 ? void 0 : data.status) === (OrderStatus === null || OrderStatus === void 0 ? void 0 : OrderStatus.REFUSED_PAYMENT) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.payAgainOrChangePaymentTime) >= new Date().getTime() ? React.createElement(React.Fragment, null, React.createElement(S.Parragraph, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusPending.StatusPending.3103723787",
    defaultMessage: "The payment was not made correctly"
  })), React.createElement(S.Buttons, null, React.createElement(S.Button, {
    onClick: function onClick() {
      return handlePayment(data === null || data === void 0 ? void 0 : data.id, data === null || data === void 0 ? void 0 : data.paymentGateway, data === null || data === void 0 ? void 0 : data.paymentToken);
    }
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusPending.StatusPending.380514933",
    defaultMessage: "Try to pay again"
  })), React.createElement(S.Button, {
    onClick: function onClick() {
      return setShowChangePaymentMethod(true);
    }
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusPending.StatusPending.3641086468",
    defaultMessage: "change payment method"
  })))) : (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.PENDING && ((data === null || data === void 0 ? void 0 : (_data$paymentStatus5 = data.paymentStatus) === null || _data$paymentStatus5 === void 0 ? void 0 : _data$paymentStatus5.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE5 = PaymentChargeStatusEnum.PENDING) === null || _PaymentChargeStatusE5 === void 0 ? void 0 : _PaymentChargeStatusE5.toLowerCase()) || (data === null || data === void 0 ? void 0 : (_data$paymentStatus6 = data.paymentStatus) === null || _data$paymentStatus6 === void 0 ? void 0 : _data$paymentStatus6.toLowerCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE6 = PaymentChargeStatusEnum.NOT_CHARGED) === null || _PaymentChargeStatusE6 === void 0 ? void 0 : _PaymentChargeStatusE6.toLowerCase())) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.transactionTimeoutTime) >= new Date().getTime() ? React.createElement(S.Button, {
    onClick: function onClick() {
      window.location.href = data === null || data === void 0 ? void 0 : data.paymentReturnUrl;
    }
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusPending.StatusPending.380514933",
    defaultMessage: "Try to pay again"
  })) : (data === null || data === void 0 ? void 0 : data.status) === OrderStatus.PENDING && React.createElement(React.Fragment, null, React.createElement(Timer, {
    maxMinutes: data === null || data === void 0 ? void 0 : data.responseTime,
    maxSeconds: 0,
    lastUpdatedAt: data === null || data === void 0 ? void 0 : data.lastUpdatedAt,
    onFinishTimer: function onFinishTimer() {}
  }), React.createElement(S.Parragraph, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, statusMessages.stepNamePendingWaiting))), errors.length > 0 && React.createElement(S.Errors, null, errors.map(function (error, index) {
    return React.createElement(S.Error, {
      key: index
    }, getErrorMessage(error.code, intl));
  })))), React.createElement(S.Aside, null, React.createElement(StatusData, {
    deliveryPhone: false,
    data: data,
    deliveryData: false
  })), React.createElement(S.Footer, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(StatusDataFooter, {
    data: data
  }))), loading && React.createElement(S.Loader, null, React.createElement(Loader, {
    fullScreen: true
  })), showChangePaymentMethod && React.createElement(AlertChangePaymentMethod, {
    currentMethodPayment: data === null || data === void 0 ? void 0 : data.paymentGateway,
    hideModal: function hideModal() {
      return setShowChangePaymentMethod(false);
    },
    handleChangePaymentMethod: function handleChangePaymentMethod(gateway, token) {
      handlePayment(data === null || data === void 0 ? void 0 : data.id, gateway, token);
      setShowChangePaymentMethod(false);
    }
  }));
};

export { StatusPending };